import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import AuthModal from './components/common/AuthModal';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import BookingPage from './pages/BookingPage';
import ServiceRecordsPage from './pages/ServiceRecordsPage';
import AboutPage from './pages/AboutPage';

function AppLayout() {
  const location = useLocation();
  const noFooter = [];
  const showFooter = !noFooter.includes(location.pathname);
  return (
    <>
      <Navbar />
      <AuthModal />
      <main>
        <Routes>
          <Route path="/"         element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/booking"  element={<BookingPage />} />
          <Route path="/records"  element={<ServiceRecordsPage />} />
          <Route path="/about"    element={<AboutPage />} />
          <Route path="*"         element={<HomePage />} />
        </Routes>
      </main>
      {showFooter && <Footer />}
    </>
  );
}

// BrowserRouter must be outermost so useNavigate works everywhere including AuthModal
export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <AppLayout />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}